import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';
import { SearchBar } from '@fiverr-private/search_bar';
import { useHeaderContext } from '../../modern/context/HeaderContext';

import './style.scss';

const SearchWrapper = ({ className, dimBackgroundEnabled = true, theme = 'dark', ...props }) => {
    const { locale, abTests, user = {}, currency = {}, rollouts = {} } = useHeaderContext();

    return (
        <div className={classNames('fiverr-header-search', className)}>
            <SearchBar
                source="top-bar"
                locale={locale}
                userId={user.id}
                abTests={abTests}
                currency={currency}
                rollouts={rollouts}
                theme={theme}
                dimBackgroundEnabled={dimBackgroundEnabled}
                {...props}
            />
        </div>
    );
};

SearchWrapper.propTypes = {
    className: string,
    theme: string,
    dimBackgroundEnabled: bool,
};

export default SearchWrapper;
